// Indonesian formatting helpers

export function formatIDR(value, opts = {}) {
  if (value === null || value === undefined || isNaN(value)) return "Rp 0";
  const { compact = false } = opts;
  if (compact) {
    const abs = Math.abs(value);
    if (abs >= 1e12) return `Rp ${(value / 1e12).toFixed(2)} T`;
    if (abs >= 1e9) return `Rp ${(value / 1e9).toFixed(2)} M`;
    if (abs >= 1e6) return `Rp ${(value / 1e6).toFixed(2)} Jt`;
  }
  return "Rp " + Math.round(value).toLocaleString("id-ID");
}

export function formatPercent(value, digits = 2) {
  if (value === null || value === undefined || isNaN(value)) return "0%";
  return (value * 100).toFixed(digits) + "%";
}

export function formatDate(s) {
  if (!s) return "-";
  // Accept yyyy-mm-dd or ISO
  const datePart = s.includes("T") ? s.split("T")[0] : s;
  const [y, m, d] = datePart.split("-");
  if (!y || !m || !d) return s;
  return `${d}-${m}-${y}`;
}

export function formatDateTime(s) {
  if (!s) return "-";
  try {
    const dt = new Date(s);
    if (isNaN(dt.getTime())) return s;
    const d = String(dt.getDate()).padStart(2, "0");
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const y = dt.getFullYear();
    const hh = String(dt.getHours()).padStart(2, "0");
    const mm = String(dt.getMinutes()).padStart(2, "0");
    return `${d}-${m}-${y} ${hh}:${mm}`;
  } catch {
    return s;
  }
}

export function severityLabel(s) {
  const map = { critical: "Kritis", warning: "Peringatan", info: "Informasi" };
  return map[s] || s;
}

export function roleLabel(r) {
  const map = {
    admin: "Administrator",
    credit_officer: "Credit Officer",
    risk_officer: "Risk Officer",
    approver: "Approver",
    viewer: "Viewer",
  };
  return map[r] || r;
}
